import { Injectable, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { contentHeaders } from 'common/headers';
import { BaseHttpService } from '../base/_base-http.service';
import { AuthService } from '../auth/auth.service';
import { BrandService } from '../brand/brand.service';
import { SessionService } from '../session/session.service';
import { Config } from '../config/env.config';
import { ListManagerService } from '../list-manager/list-manager.service';
import { ListManagerModel } from '../list-manager/list-manager.model';
import { getSearchParamsFromQuery } from '../search/search-helpers';
import {catchError, map} from 'rxjs/operators';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';



@Injectable()
export class FitmentsListService extends ListManagerService {

  API_URL: string = 'fitment-list';

  get fetchUrl(): string {
    return `${this.API_URL}/${this.brandId}`;
  }

  get createNewListUrl(): string {
    return this.fetchUrl;
  }

  createNewList(name: string): Observable<any> {
    return super.createNewList(name)
    .pipe(map( (response: any) => {
      response.data_list = response.fitment_list;
      return response;
    }));
  }

  addToList(
    data: Array<any>,
    listId: any
  ): Observable<any> {
    const body = JSON.stringify({ data });
    return this.http.post(
      `${Config.API}/${this.API_URL}/add-apps/${this.brandId}/${listId}`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  addToLists(
    ids: Array<number|string>,
    selectedLists: Array<ListManagerModel>,
    filter?: any
  ): Observable<any> {
    let body: any;
    const listIds: Array<any> = _.map(selectedLists, '_id');
    if (filter) {
      body = JSON.stringify({
        state: _.get(filter, 'state'),
        filter: _.get(filter, 'filter'),
        data: {listIds}
      });
    } else {
      body = JSON.stringify({
        data: ids,
        fitmentListIds: listIds,
      });
    }
    return this.http.post(
      `${Config.API}/${this.API_URL}/add-apps/${this.brandId}`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  removeFromList(
    data: Array<any>,
    listId: any
  ): Observable<any> {
    const body = JSON.stringify({ data });
    return this.http.post(
      `${Config.API}/${this.API_URL}/remove-apps/${this.brandId}/${listId}`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }


  addAllInSearchToList(
    searchQuery: string,
    listId: any,
    productId?: any,
    fitmentListId?: any
  ): Observable<any> {
    const data = this.getSearchParamsFromQuery(searchQuery);
    data.insert_query_results = true;
    if (productId) {
      data.item_detail_id = productId;
    }
    if (fitmentListId) {
      data.fitment_list_id = fitmentListId;
    }

    let url =  `${Config.API}/${this.API_URL}/add-apps/${this.brandId}/${listId}`;
    let body = null;
    if (_.isArray(listId)) {
      const fitmentListIds = listId;
      body = JSON.stringify({ data, fitmentListIds });
      url =  `${Config.API}/${this.API_URL}/add-apps/${this.brandId}`;
    } else {
      body = JSON.stringify({ data });
    }
    return this.http.post( url, body, {headers: contentHeaders})
        .pipe(catchError(this.handleError.bind(this)));
  }

  addAllInSearchToListBunch(
    searchQuery: string,
    selectedLists: Array<ListManagerModel>,
    productId?: any,
    fitmentListId?: any
  ): Observable<any> {
    const listIds = _.map(selectedLists, '_id');
    return this.addAllInSearchToList(searchQuery, listIds, productId, fitmentListId);
  }

  removeAllInSearchFromList(
    searchQuery: string,
    listId: any
  ): Observable<any> {
    const data = this.getSearchParamsFromQuery(searchQuery);
    data.remove_query_results = true;
    delete data.columns;
    const body = JSON.stringify({ data });
    return this.http.post(
      `${Config.API}/${this.API_URL}/remove-apps/${this.brandId}/${listId}`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  removeAllInSearchFromListBunch(
    searchQuery: string,
    selectedLists: Array<ListManagerModel>
  ): Observable<any> {
    const requests = _.map(selectedLists, (item: ListManagerModel) => {
      return this.removeAllInSearchFromList(searchQuery, item._id);
    });
    return forkJoin(requests)
        .pipe(catchError((this.handleError.bind(this))));
  }

  private getSearchParamsFromQuery(searchQuery: string): any {
    return _.omit(
      getSearchParamsFromQuery(searchQuery),
      ['page', 'itemsPerPage', 'sortCol', 'sortDir']
    );
  }
}
